<template>
  <div v-if="list.length > 0">
    <template v-for="(item, index) of list">
      <div @click="cb(item)" :key="index" :class="{ 'timeline-wrapper': true, even: (index + 1) % 2 === 0 }">
        <div :class="{ timeline: true, reverse: (index + 1) % 2 === 0}">
          <div class="timeline-content" @click="gotoCaseDial(item.caseId)">
            <p class="timeline-content__time">
              {{item.author}}
              <span>{{item.time}}</span>
            </p>
            <p class="timeline-content__message">{{item.message}}</p>
          </div>
          <div class="timeline-label">
            {{item[date]}}
            <div class="icon">
              <svg style="width: 1em; height: 1em; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 32px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" data-spm-anchor-id="a313x.7781069.0.i2">
                <path d="M511.99693 47.862078c-256.292154 0-464.113363 207.763904-464.113363 464.11234 0 256.290107 207.823256 464.11541 464.113363 464.11541 256.350482 0 464.113363-207.825302 464.113363-464.11541C976.110293 255.625982 768.346389 47.862078 511.99693 47.862078zM782.729981 705.417151 241.294578 705.417151 241.294578 447.37105l189.330066 131.259486c24.143886 16.499789 52.846602 23.626094 81.372286 23.749914 28.40391-0.061398 57.075927-7.250124 81.279165-23.749914l189.453886-131.259486L782.729981 705.417151zM782.729981 372.072087 558.043662 527.748682c-11.025101 7.733125-28.460192 12.811794-46.047756 12.750395-17.736966 0.061398-35.172057-5.01727-46.110177-12.750395L241.294578 372.133485l0-53.599755 541.435403 0L782.729981 372.072087z" fill="#f6ac19">
                </path>
              </svg>
              <!-- <svg style="width: 1em; height: 1em; vertical-align: middle; fill: currentcolor; overflow: hidden; font-size: 32px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5555" data-spm-anchor-id="a313x.7781069.0.i6"><path d="M512 902.582857a585.874286 585.874286 0 0 1-87.454476-6.363428h-6.412191c-10.678857 0-21.333333 4.242286-29.866666 10.581333l-117.345524 110.201905a23.137524 23.137524 0 0 1-14.921143 6.339047 21.308952 21.308952 0 0 1-21.333333-21.211428v-148.284953c0-14.823619-8.533333-29.671619-21.333334-36.010666C85.333333 739.449905 0 625.030095 0 474.599619 0 228.839619 228.278857 48.761905 512 48.761905c283.745524 0 512 180.077714 512 425.837714 0 245.76-228.254476 427.983238-512 427.983238z m0-811.446857c-266.678857 0-469.333333 165.254095-469.333333 383.463619 0 125.001143 66.145524 226.694095 194.145523 305.103238 25.6 14.823619 40.521143 42.374095 40.521143 72.021333v97.450667l81.066667-76.263619a82.724571 82.724571 0 0 1 57.61219-23.30819h12.77562a543.695238 543.695238 0 0 0 81.091047 6.339047c266.654476 0 469.333333-165.229714 469.333333-383.463619C981.333333 256.390095 778.678857 91.136 512 91.136z m213.333333 447.024762A42.666667 42.666667 0 0 1 682.666667 495.786667a42.666667 42.666667 0 0 1 42.666666-42.374096c23.454476 0 42.666667 19.065905 42.666667 42.374096a42.666667 42.666667 0 0 1-42.666667 42.374095z m-213.333333 0a42.666667 42.666667 0 0 1-42.666667-42.374095A42.666667 42.666667 0 0 1 512 453.412571c23.454476 0 42.666667 19.065905 42.666667 42.374096A42.666667 42.666667 0 0 1 512 538.160762z m-213.333333 0a42.666667 42.666667 0 0 1-42.666667-42.374095 42.666667 42.666667 0 0 1 42.666667-42.374096c23.478857 0 42.666667 19.065905 42.666666 42.374096a42.666667 42.666667 0 0 1-42.666666 42.374095z" fill="#f6ac19"></path>
              </svg> -->
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';

export default {
  props: {
    date: {
      type: String,
      default() {
        return 'date';
      }
    },
    time: {
      type: String,
      default() {
        return 'time';
      }
    },
    message: {
      type: String,
      default() {
        return 'message';
      }
    },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    cb: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      arr: this.list
    };
  },
  methods: {
    gotoCaseDial(caseId) {
      console.warn('this.messages');
      console.warn(caseId);
      window.open(`/main/case/detail/${Base64.encode(caseId)}`);
    }
  }
};
</script>
<style scoped>
.timeline-wrapper.even {
  padding-left: 50%;
}
.timeline {
  display: flex;
  width: 50%;
  /* margin-bottom: 10px; */
  flex-direction: row;
  background-color: #fef7e8;
  border-right: 3px solid #f6ac19;
  cursor: pointer;
}
.timeline.reverse {
  width: 100%;
  flex-direction: row-reverse;
  border-left: 3px solid #f6ac19;
  border-right: none;
}
.timeline .timeline-label {
  flex: 0 1;
  position: relative;
  padding: 0 10px;
  min-width: 100px;
  color: #f6ac19;
  align-self: center;
  font-weight: 500;
  white-space: nowrap;
}
.timeline.reverse .timeline-label {
  text-align: right;
}
.timeline .timeline-label .icon {
  position: absolute;
  top: -10px;
  right: -23px;
  background: #fff;
  padding: 5px;
  border-radius: 50%;
}
.timeline.reverse .timeline-label .icon {
  right: auto;
  left: -23px;
}
.timeline .timeline-content {
  flex: 1 0;
  padding: 10px;
  background: #f8f8f8;
}
.timeline.reverse .timeline-content {
  padding-left: 30px;
}
.timeline .timeline-content .timeline-content__time {
  margin: 0 8px 0 0;
  font-weight: 500;
  font-style: italic;
}
.timeline .timeline-content .timeline-content__time span {
  margin-left: 12px;
  font-size: 12px;
}
.timeline .timeline-content .timeline-content__message {
  margin: 5px 0;
}
</style>




// WEBPACK FOOTER //
// src/components/TimeLine.vue